module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Emergence - Book One of the Alicorn Quest")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006"
    }
  }, [_vm._v("Part 1")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#chapter-1-mamallapuram"
    }
  }, [_vm._v("Chapter 1: "), _c('span', [_vm._v("Mamallapuram")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0024#chapter-2-the-bangle-and-star"
    }
  }, [_vm._v("Chapter 2: The Bangle and Star")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0002#chapter-3-disaster"
    }
  }, [_vm._v("Chapter 3: Disaster")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#chapter-4-lost-temples",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Lost Temples")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0004#afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0005#chapter-5-madras",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Madras")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0006#chapter-6-evil-anticipation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Evil Anticipation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0007#chapter-7-diwali",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Diwali")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#chapter-8-the-merchant-ship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Merchant Ship")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0009#chapter-9-agilan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Agilan")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0010#chapter-10-it-is-written",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: It is Written")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#chapter-11-the-path",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Path")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0012#chapter-12-custom-house",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Custom House")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#chapter-13-uncertainty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Uncertainty")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0014#chapter-14-the-tuscany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Tuscany")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0015#chapter-15-last-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Last Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0016#chapter-16-leaving-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Leaving Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0017#chapter-17-setting-sail",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Setting Sail")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0018#chapter-18-eastern-oregon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Eastern Oregon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#chapter-19-fire-creek",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Fire Creek")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0020#chapter-20-annie-and-samuel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Annie and Samuel")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0021#chapter-21-new-friendship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: New Friendship")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0022#chapter-22-princess-kooskooskia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Princess Kooskooskia")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0023#chapter-23-caring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Caring")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0